import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ShareModal from "@/components/ShareModal";
import { Award, Printer, Share2 } from "lucide-react";

export default function Certificate() {
    const { id } = useParams();
    const [cert, setCert] = useState(null);
    const [shareOpen, setShareOpen] = useState(false);
    const [journeyCover, setJourneyCover] = useState(null);

    useEffect(() => {
        api.get(`/certificates/${id}`).then(async (r) => {
            setCert(r.data);
            // also pull the journey to get its cover for the share card
            try {
                const all = (await api.get("/journeys")).data;
                const j = all.find((j) => j.id === r.data.journey_id);
                if (j) setJourneyCover(j.cover);
            } catch { /* ignore */ }
        }).catch(()=>{});
    }, [id]);

    if (!cert) return <div className="min-h-screen"><Header /><div className="p-20 font-body text-[#5C5C5C]">Carregando certificado...</div></div>;

    return (
        <div className="min-h-screen relative grain">
            <Header />
            <main className="max-w-[1400px] mx-auto px-6 md:px-10 pt-12 pb-24">
                <div className="flex items-center justify-between print:hidden">
                    <Link to="/perfil" className="font-body text-sm text-[#5C5C5C] hover:text-[#1A1A1A]">← Voltar ao perfil</Link>
                    <div className="flex items-center gap-3">
                        <button onClick={() => setShareOpen(true)} data-testid="share-certificate" className="btn-primary">
                            <Share2 className="w-4 h-4" /> Compartilhar
                        </button>
                        <button onClick={() => window.print()} data-testid="print-certificate" className="btn-holo">
                            <Printer className="w-4 h-4" /> Imprimir / PDF
                        </button>
                    </div>
                </div>

                <div data-testid="certificate-frame" className="cert-frame mt-10 p-10 md:p-20 text-center">
                    <Award className="w-12 h-12 mx-auto text-[#D4AF37]" />
                    <div className="overline text-[#5C5C5C] mt-4">Instituto de Medicina Quântica</div>
                    <h1 className="font-editorial italic text-4xl md:text-6xl mt-6">Certificado de Conclusão</h1>

                    <div className="mt-12 font-body text-[#5C5C5C]">Certificamos que</div>
                    <div className="font-display text-3xl md:text-5xl mt-3 tracking-tight">{cert.user_name}</div>

                    <div className="mt-10 font-body text-[#5C5C5C] max-w-2xl mx-auto">
                        concluiu com integralidade a jornada
                    </div>
                    <div className="font-editorial italic text-2xl md:text-3xl text-[#1A1A1A] mt-3">{cert.journey_title}</div>

                    <div className="mt-10 inline-flex items-center gap-6 font-body text-sm text-[#5C5C5C]">
                        <div>
                            <div className="overline">Carga horária</div>
                            <div className="font-display text-lg text-[#1A1A1A] mt-1">{cert.hours} horas</div>
                        </div>
                        <div className="w-px h-10 bg-black/10" />
                        <div>
                            <div className="overline">Data</div>
                            <div className="font-display text-lg text-[#1A1A1A] mt-1">{new Date(cert.issued_at).toLocaleDateString("pt-BR")}</div>
                        </div>
                    </div>

                    <div className="mt-14 max-w-md mx-auto">
                        <div className="h-px bg-[#D4AF37]/40" />
                        <div className="font-editorial italic mt-3">Instituto de Medicina Quântica</div>
                        <div className="font-body text-xs text-[#5C5C5C]">Assinatura digital · ID {cert.id.slice(0, 8)}</div>
                    </div>
                </div>
            </main>
            <Footer />
            <ShareModal
                open={shareOpen}
                onClose={() => setShareOpen(false)}
                variant="certificate"
                userName={cert.user_name}
                journeyTitle={cert.journey_title}
                journeyCover={journeyCover}
                hours={cert.hours}
            />
        </div>
    );
}
